/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { withPrefix } from 'gatsby'

import useData from './useData'

import Header from "./header"
import Nav from "./nav"
import "./layout.scss"

const LayoutTop = ({ children }) => {
  const data = useData()

  return (
    <>
    <div id="type2019" className="top">
      <div className="wrapper wrap_top" id="js-animation">
        <Header siteTitle={data.site.siteMetadata.title} />
        <div className="wrapInner">
          <main>{children}</main>
        </div>
      </div>

      <Nav />
      <div className="saologo"></div>

			<footer className="footer">
				<div className="footerInner">
          {/*
					<div className="footerLeft">
						<div className="footerLabel"><span className="img">NewsTopics</span></div>
						<div className="footerNews"><p><span>2023.10.13</span>エントリー受付を開始しました。</p></div>
					</div>
          */}
          {/*
					<div className="footerLeft">
						<div className="footerLabel"><span className="img">NewsTopics</span></div>
						<div className="footerNews"><p><span>2024.01.26</span>グランプリ結果を公開しました。</p></div>
					</div>
          */}
					<div className="footerRight"></div>
					<div className="clearbox"></div>
				</div>
			</footer>

      <script src={withPrefix('/js/jquery.min.js')} />
      <script src={withPrefix('/js/base.js?v=20190925')} />
    </div>
    </>
  )
}

LayoutTop.propTypes = {
  children: PropTypes.node.isRequired,
}

export default LayoutTop
